module.exports = __webpack_public_path__ + "img/area-VIP-service.fa61aa9c.jpg";